module.exports = __webpack_public_path__ + "static/media/img_bg_texture_white.c08a78db.png";